import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

type ContainerSize = 'content' | 'site'

const containerSizeClasses: Record<ContainerSize, string> = {
  content: 'mx-auto w-full max-w-6xl px-4 lg:px-8',
  site: 'mx-auto w-full max-w-[1400px] px-6 lg:px-8',
}

export function Container({
  children,
  className,
  size = 'content',
}: {
  children: ReactNode
  className?: string
  size?: ContainerSize
}) {
  return <div className={cn(containerSizeClasses[size], className)}>{children}</div>
}
